import { takeLatest } from 'redux-saga'
import { call, put, take, fork, select, race } from 'redux-saga/effects'
import actionTypes from '../actions/actionTypes'
import { onboardingSelectors } from 'redux/selectors'
import { userSync, onboardingSync } from '../../sync'
import config from 'config'
import redirectTo from 'helpers/redirection'
import browserHistory from 'helpers/history'
import onboardingActions from 'redux/actions/onboardingActions'

function wait(time) {
	return new Promise(function(resolve) {
		setTimeout(function() {
			resolve(true)
		}, time)
	})
}

function *getLoadedAssets() {
	while (true) {
		yield take([actionTypes.ONBOARDING_LESSON_ASSET_LOADED, actionTypes.ONBOARDING_LOADING_COMPLETE, actionTypes.ONBOARDING_LOOP_COMPLETE])
		try {
			const onboardingAssetsData = yield select(onboardingSelectors.getOnboardingLoadedAssets)
			if (onboardingAssetsData.exitComplete) {
				yield call(wait, 200)
				while (true) {
					const {task} = yield race({
						task: call(wait, 150),
						cancel: take([actionTypes.ONBOARDING_CHANGE_STEP]),
					})
					if (task) {
						const onboardingData = yield select(onboardingSelectors.getOnboardingViewData)
						if (onboardingData.onboarding.activatedLessons < 8) {
							yield put({
								type: actionTypes.ONBOARDING_LESSON_ACTIVATED,
							})
						} else {
							break
						}
					} else {
						break
					}
				}
			} else {
			}
		} catch (error) {
			// console.log(error)
		}
	}
}

function *handleStepChange() {
	while (true) {
		yield take([actionTypes.ONBOARDING_CHANGE_STEP, actionTypes.ONBOARDING_INITIALIZE])
		try {
			const stepData = yield select(onboardingSelectors.getStepData)
			if (stepData.step === 3) {
				if (stepData.fromStore) {
					const response = yield call(onboardingSync.getOnboardingSuggestedEntities)
					yield put({
						type: actionTypes.ONBOARDING_SUGGESTED_CATEGORIES_FETCHED,
					})
					redirectTo(response.payload.store_search_url)
				} else {
					const response = yield call(onboardingSync.getOnboardingEntities)
					yield put({
						type: actionTypes.ONBOARDING_SUGGESTED_LESSONS_FETCHED,
						entities: response.payload.entities,
					})
				}

			}

		} catch (error) {
			// console.log(error)
		}
	}
}

function *navigateToStep(action) {
	yield put({
		type: actionTypes.ONBOARDING_TRANSITION_STEP,
	})
	browserHistory.push('/welcome/' + action.step)
	yield call(wait, 10)
	yield put({
		type: actionTypes.ONBOARDING_RESET_STEP_TRANSITION,
	})
}

function *saveGrades() {
	const gradesData = yield select(onboardingSelectors.getGradesData)
	if (gradesData.updated) {
		yield call(userSync.saveTeacherInfo, gradesData.gradeIds)
		yield put(onboardingActions.gradesSaved(gradesData.gradeIds))
	}
	yield put(onboardingActions.navigateToStep(2, false))
}

function *saveSubjects() {
	const subjectsData = yield select(onboardingSelectors.getSubjectsData)
	if (subjectsData.updated) {
		yield call(userSync.saveTeacherInfo, null, subjectsData.subjectIds)
		yield put(onboardingActions.subjectsSaved(subjectsData.subjectIds))
	}
	yield put(onboardingActions.navigateToStep(3, false))
}

function *saveInterests() {
	const interestsData = yield select(onboardingSelectors.getInterestsData)
	yield call(userSync.saveOnboardingQuestion, '1', interestsData.interestsIds)
	yield put(onboardingActions.navigateToStep(2, false))
}

function *saveTechnology() {
	const technologyData = yield select(onboardingSelectors.getTechnologyData)
	yield call(userSync.saveOnboardingQuestion, '2', technologyData.technologyIds)
	window.open(config.app+'library', '_self')
}

function *addLessonsToLibrary() {
	try {
		const addLessonsData = yield select(onboardingSelectors.getAddLessonsData)
		const response = yield call(onboardingSync.addOnboardingLessons, addLessonsData.selected.join(','))
		if (response.error_code === 0 || response.error_code === 1) {
			window.open(config.app+'library', '_self')
		}
	} catch (err) {

	}
}

export default [
	fork(getLoadedAssets),
	fork(handleStepChange),
	takeLatest(actionTypes.ONBOARDING_ADD_TO_LIBRARY, addLessonsToLibrary),
	takeLatest(actionTypes.ONBOARDING_SAVE_GRADES, saveGrades),
	takeLatest(actionTypes.ONBOARDING_SAVE_SUBJECTS, saveSubjects),
	takeLatest(actionTypes.ONBOARDING_SAVE_INTERESTS, saveInterests),
	takeLatest(actionTypes.ONBOARDING_SAVE_TECHNOLOGY, saveTechnology),
	takeLatest(actionTypes.ONBOARDING_NAVIGATE_TO_STEP, navigateToStep),
]
